import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  align: PropTypes.oneOf(['left', 'center'])
};
const IconTile = createComponent({
  displayName: 'IconTile',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const classNameSet = new Set(['swan-icon-tile']);
      const {
        align = 'center'
      } = props;
      if (align != 'center') classNameSet.add("swan-icon-tile-align-".concat(align));
      return classNameSet;
    }
  }
});
export { IconTile };